import React, { useState } from 'react'
import Dialog from '@react/react-spectrum/Dialog'
import Textfield from '@react/react-spectrum/Textfield'
import Checkbox from '@react/react-spectrum/Checkbox'
import './DeleteProject.scss'

export const DeleteProjectDialog = ({ projectId, title, propertyID, onSubmit, ...otherProps }) => {
  const [disabled, setDisabled] = useState(true)
  const [deleteTags, setDeleteTags] = useState(false)

  return (
    <Dialog
      variant='destructive'
      title='Delete project'
      confirmLabel='Delete'
      cancelLabel='Cancel'
      confirmDisabled={disabled}
      onConfirm={() => onSubmit(deleteTags)}
      {...otherProps}
      role='dialog'
    >
      <p>
        You are trying to delete project <b>{title}</b> with ID <b>{projectId}</b>.
      </p>
      <p>Please re-type project ID below to confirm.</p>
      <Textfield placeholder={projectId} onChange={(v) => setDisabled(v !== projectId)} />

      {/* {propertyID && (
        <div className='delete-project-checkbox'>
          <Checkbox onChange={(value) => setDeleteTags(value)} value={deleteTags}>
            Delete the Data Collection and Datastream connected to this project
          </Checkbox>
        </div>
      )} */}
    </Dialog>
  )
}
